"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = publish;
var uuid_1 = require("uuid");
function publish(topic, common, data) {
    var id = (0, uuid_1.v4)();
    var eventName = data.event_name;
    var payload = {
        topic: topic,
        schema_id: eventName,
        data: __assign(__assign({ event_id: id, timestamp: new Date().toISOString() }, common), data),
        attributes: {
            event_id: id,
        },
    };
    console.log("%cEVENT PUBLISH", "padding: 0 5px; background-color: #00aa00; color: white;", eventName, payload);
    fetch("https://pubsub-proxy.skypicker.com/publish", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    }).catch(function (err) {
        console.error("%cEVENT PUBLISH ERROR", "padding: 0 5px; background-color: #aa0000; color: white;", eventName, err, payload);
    });
}
//# sourceMappingURL=index.js.map